module.exports = {
    methods: {
        showTopicMeta(topic) {
            return topic.hideTime === 'n' && topic.formattedDate || topic.hideLocation === 'n' && topic.location;
        }
    }
};
